import ProgressForm from "../components/ProgressForm"

const Create = () =>{
    return(
        <div>
            <ProgressForm/>
        </div>
    )
}

export default Create